import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SearchIcon from '../../../../../../../../components/icons/SearchIcon';
import FormGroup from '../../../../../../../../components/global/FormGroup';
import DismissCircleIcon from '../../../../../../../../components/icons/DismissCircleIcon';
import Button from '../../../../../../../../components/global/Button';
import useDebounce from '../../../../../../../../hooks/useDebounce';

const propTypes = {
  searchQuery: PropTypes.string.isRequired,
  setSearchQuery: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
};

const ProUserPageSearchFilter = ({
  searchQuery,
  setSearchQuery,
  placeholder = 'Search events...',
  className = '',
}) => {
  const [localSearch, setLocalSearch] = React.useState(searchQuery ?? '');
  const [debouncedLocalSearch] = useDebounce(localSearch, 500);

  useEffect(() => {
    if (searchQuery !== localSearch) {
      setLocalSearch(searchQuery);
    }
  }, [searchQuery]);

  useEffect(() => {
    setSearchQuery(debouncedLocalSearch);
  }, [debouncedLocalSearch]);
  const classes = classNames({
    'album-folders-home-filter-search shutterbug-folders': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <SearchIcon color="#646e71" />
      <FormGroup
        id="pro-user-events-search"
        className="mb-0 album-folders-filter-search shutterbug-folders"
        name="pro_user_events_search"
        type="text"
        label="Search Events"
        labelSrOnly
        size="lg"
        placeholder={placeholder}
        value={localSearch}
        onChange={({ target }) => {
          setLocalSearch(target.value);
        }}
        autoComplete="off"
      />
      {localSearch && (
        <Button
          btnStyle="reset"
          className="clear-search-btn shutterbug-clear-btn"
          onClick={() => setLocalSearch('')}
        >
          <DismissCircleIcon color="#f2f3f3" crossColor="#646e71" size={24} />
        </Button>
      )}
    </div>
  );
};

ProUserPageSearchFilter.propTypes = propTypes;

export default ProUserPageSearchFilter;
